<template>
  <scroll-center-dialog v-model="opened" @close="close" @apply="save" :title="form_title" :scrolled="false">
    <v-card-text>
      <v-alert type="info">
        Вводим почту если нужно изменить ее и отправить почту отличную от {{item.visitor.send}}
      </v-alert>
      <v-text-field :error="hasError('email')"
                    :error-messages="getError('email')"
                    label="Новая почта"
                    outlined
                    v-model="value.email"
      ></v-text-field>
      
      <v-alert type="error" v-if="hasError('non_field_errors')">
        {{ getError('non_field_errors') }}
      </v-alert>
      <v-alert type="error" v-if="hasError('detail')">
        {{ getError('detail') }}
      </v-alert>
      <v-alert type="error" v-if="hasError('error')">
        {{ getError('error') }}
      </v-alert>
    </v-card-text>
  </scroll-center-dialog>
</template>

<script>
import urls from '@/urls/helper.js'
import {loadData, makeGetRequest, makePostRequest} from "@/helper/requests";
import {generateListUidToName} from "@/helper/uidToName";
import selectors from "@/urls/selectors";
import LoadingAutocomplete from "@/modules/templates/LoadingAutocomplete.vue";
import ScrollCenterDialog from "@/modules/templates/ScrollCenterDialog.vue";
import FormErrorsMixin from "@/mixins/FormErrorsMixin";
import {mapActions} from "vuex";

export default {
  name: "ReSendDialog",
  mixins: [FormErrorsMixin],
  components: {LoadingAutocomplete, ScrollCenterDialog},
  props: {
    item: Object,
    opened: Boolean,
    edit: Boolean,
  },
  data() {
    return {
      value: {
        email: undefined
      },
    }
  },
  computed: {
  },
  methods: {
    ...mapActions({
      executeEmailResend: 'emails/executeEmailResend',
    }),
    save() {
      if (this.item) {
        this.executeEmailResend({
          id: this.item.id,
          data: this.value,
          finalizer: (val) => {
            this.$emit('close', val)
          },
          catcher: (val) => {
            this.mapErrors(val)
          },
        })
      }
    },
    close() {
      this.$emit('close', false)
    },

  },
}
</script>

<style scoped>
</style>
